<div *ngIf="alertService.alerts.length">

	<h2>Messages</h2>
	<button class="clear"
					(click)="alertService.clear()">Clear Alerts</button>
	<div *ngFor='let alert of alertService.alerts'> {{alert.message}} </div>

</div>



<!-- testing -->

